import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { css } from "glamor";
import LessonQuestionCarousel from "./LessonQuestionCarousel";
import { getCurrentLesson } from "../../selectors/lessonSelectors";
import { getFlattenedLessonQuestions, getCurrentLessonQuestionAndStem } from "../../selectors/lessonQuestionSelectors";
import { getCurrentUser } from "../../selectors/userSelectors";
import { fetchQuestionReplies } from "../../processes/replyProccess";
import { fetchLessonAnswers } from "../../processes/answerProccess";
import { getLessonQuestionAnswered } from "../../selectors/answerSelector";
import useScreenVerticalOffset from "../../utils/useScreenVerticalOffset";
import Spinner from "../library/Spinner";

const loadingContainer = css({
  position: "relative",
  width: "100%",
  paddingBottom: "56.25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const spinnerWrapper = css({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const LessonQuestionContainer = (props) => {
  const {
    flattenedLessonQuestions,
    currentQuestionIndex,
    currentQuestionItem,
    lesson,
    dispatch,
    questionReady,
  } = props;
  const questionRef = useRef(null);
  const [wasAlerted, setWasAlerted] = useState(false);

  useEffect(() => {
    if (lesson?.id && (lesson?.meta?.question || (lesson?.meta?.questions && lesson.meta.questions.length > 0))) {
      fetchLessonAnswers(dispatch, lesson?.courseId, lesson.id);
    }
  }, [dispatch, lesson]);

  useEffect(() => {
    if (lesson?.id) {
      const questionIds = [];

      if (lesson.meta?.question) {
        questionIds.push(lesson.meta.question);
      }

      if (lesson.meta?.questions && Array.isArray(lesson.meta.questions)) {
        lesson.meta.questions.forEach((questionId) => {
          if (questionId) {
            questionIds.push(questionId);
          }
        });
      }

      if (questionIds.length > 0) {
        questionIds.forEach(questionId => {
          fetchQuestionReplies(dispatch, questionId);
        });
      }
    }
  }, [dispatch, lesson?.id, lesson?.meta?.question, lesson?.meta?.questions]);

  const scrollAmount = useScreenVerticalOffset();

  useEffect(() => {
    scrollAmount > 100 && wasAlerted == false && setWasAlerted(true);
  }, [wasAlerted, scrollAmount]);

  const hasQuestions = flattenedLessonQuestions && flattenedLessonQuestions.length > 0;
  const currentQuestion = currentQuestionItem?.question;
  const isLoading = props.loadingAnswer || props.loadingAlternatives;

  if (isLoading) {
    return (
      <div className={loadingContainer}>
        <div className={spinnerWrapper}>
          <Spinner />
        </div>
      </div>
    );
  }

  if (!hasQuestions || !questionReady || !currentQuestion) {
    return null;
  }

  return (
    <LessonQuestionCarousel
      wasAlerted={wasAlerted}
      scrollAmount={scrollAmount}
      questionRef={questionRef}
      flattenedLessonQuestions={flattenedLessonQuestions}
      currentQuestionIndex={currentQuestionIndex}
      lesson={lesson}
      {...props}
    />
  );
};

function mapStateToProps(state) {
  const currentLessonId = state.currentLessonId;
  const lesson = getCurrentLesson(state, currentLessonId);
  const flattenedLessonQuestions = getFlattenedLessonQuestions(state);
  const currentQuestionIndex = state.lesson.currentQuestionIndex;
  const currentQuestionItem = getCurrentLessonQuestionAndStem(state);
  const loadingAlternatives = state.lesson.loadingAlternatives;
  const loadingAnswer = state.lesson.loadingAnswer;

  const answered = getLessonQuestionAnswered(state, {
    questionItem: currentQuestionItem,
    lessonId: lesson?.id,
  });

  return {
    lesson,
    flattenedLessonQuestions,
    currentQuestionIndex,
    currentQuestionItem,
    currentUser: getCurrentUser(state),
    selectedReply: state.lesson.selectedReply,
    questionReady: !loadingAlternatives && !loadingAnswer,
    answered,
    loadingAlternatives,
    loadingAnswer,
  };
}

export default connect(mapStateToProps)(LessonQuestionContainer);
